import { gql } from '@apollo/client'

export const PROJECT_QUERY = gql`
  query project($id: ID!) {
    project(id: $id) {
      id
      title
      interface
      archived
      collisionDetectionEnabled
      clientPayment
      policyNumberRegex
      policyNumberMask
      claimNumberRegex
      claimNumberMask
      additionalIncomeBillable
      withLeadingClaimNumber
      contactAttemptSmsEnabled
      contactAttemptSmsText
      closingSmsEnabled
      closingSmsText
      contractValidationSmsEnabled
      contractValidationSmsText
      callCenterLegalAdvice
      handoverTypeRequired
      closingInfoEmail
      showForwardSmsButton
      forwardDefaultText
      externalRsv
    }
  }
`
